var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3294 17.7273H17.3244C17.3466 17.7273 17.361 17.7037 17.3514 17.6832L16.9556 16.8669L13.6431 10.0442C13.5698 9.89345 13.3559 9.89345 13.2827 10.0442L11.1044 14.532L9.8068 11.8588C9.74732 11.7358 9.59414 11.7129 9.49922 11.7895L6.60007 17.7273H0.670804C0.175797 17.7273 -0.147999 17.207 0.0682655 16.7602L7.88925 0.65071C8.13375 0.146703 8.84922 0.146703 9.09372 0.65071L12.0001 6.6379L14.9064 0.65071C15.1509 0.146703 15.8664 0.146703 16.1109 0.65071L23.9319 16.7602C24.1482 17.207 23.8244 17.7273 23.3294 17.7273Z",
    fill: "#FE7E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmLogo);
export default __webpack_public_path__ + "static/media/mm-logo.997531bae7bb249e6c9a06d8d2966e2b.svg";
export { ForwardRef as ReactComponent };